import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { SnackbarMessage } from '@cardapio-online/core/snackbar/snackbar';

@Component({
  selector: 'lib-ui-snackbar-item',
  templateUrl: './ui-snackbar-item.component.html',
  styleUrl: './ui-snackbar-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiSnackbarItemComponent {
  @Input({ required: true }) message!: SnackbarMessage;
  @Output() dismissed = new EventEmitter<string>();

  protected dismiss(): void {
    this.dismissed.emit(this.message.id);
  }
}
